import { FC, ReactNode } from 'react';
import style from './index.module.scss';

/**
 * Props
 * @param {string} title
 * @param {ReactNode} children
 */
interface Props {
  title: string;
  children: ReactNode;
}

/** モーダル表示系の条件でタイトルとボタンを持つ */
export const TitleWithButton: FC<Props> = ({ title, children }) => {
  return (
    <div className={style['title-with-button__wrapper']}>
      <p className={style['title-with-button__title']}>{title}</p>
      {children}
    </div>
  );
};
